import { environment } from '../../../environments/environment';
import { Adapter } from './adapter';
import { MachineGroup } from './machine-group';

export class ActiveModel {
  constructor(
    public hash?: string,
    public name?: string,
    public reference?: number,
    public order?: number,
    public imagePath?: string,
    public active?: boolean,
    public brandImage?: string,
    public brandBWImage?: string,
    public defaultTaskDeviation?: number,
    public vibration?: boolean,
    public adapter?: Adapter,
    public defaultToolTime?: number,
    public defaultPieceTime?: number,
    public timeCorrector?: number,
    public readMode?: string,
    public workingModelGroup?: MachineGroup,
    public allowsWriting?: boolean,
  ) { }

  get nameReference() {
    return (this.reference) ? `${ this.name } ${ this.reference }` : this.name;
  }

  get imageUrl() {
    return `${ environment.imageUrl }${ this.imagePath }`;
  }

  get brandImageUrl() {
    return `${ environment.imageUrl }${ this.brandImage }`;
  }
}



// WEBPACK FOOTER //
// /var/www/borneo/prod/borneo_app/src/app/core/models/active-model.ts